import { csosApiService } from "../services/api/csosApiService";

export const fetchAndProcessOrder = (
  orderId: string,
  account: string,
): Promise<any | null> => {
  return csosApiService.getPendingOrder(orderId, account).then((response) => {
    if (response.body && response.body.orders[0] && response.body.orders[0].orderLines.length !== 0) {
      const o = response.body.orders[0];
      o.orderLines.forEach((ol: any) => { ol.oldOrderQuantity = ol.orderQuantity; });
      return o;
    }
    return null;
  });
};
